<template>

    <div class="customers">
        <v-table>
            <thead>
                <th class="pr-0">
                    <v-checkbox :model="selected.length === customers.length" @input="selectAll" />
                </th>
                <th></th>
                <th class="sortable" v-for="trait in traits" :key="trait.id" @click="sort(trait.field)">
                    <div>
                        <span>{{ trait.name }}</span>
                        <i v-if="$route.query.sort_key === trait.field && $route.query.sort_dir === 'desc'" class="fas fa-caret-down"></i>
                        <i v-if="$route.query.sort_key === trait.field && $route.query.sort_dir === 'asc'" class="fas fa-caret-up"></i>
                    </div>
                </th>
            </thead>
            <tbody>
                <tr v-for="customer in customers" :key="customer.id" @click="viewCustomer($event, customer)">
                    <td @click.stop>
                        <v-checkbox :model="selected.indexOf(customer.id) >= 0" @input="selectRow(customer.id, $event)" />
                    </td>
                    <td class="w-34 p-0">
                        <v-avatar
                            :name="customer.initials"
                            :color="customer.color"
                            :url="customer.gravatar ? customer.gravatar + '&s=80' : ''"
                            :size="34"
                            :radius="17">
                        </v-avatar>
                    </td>
                    <td v-for="trait in traits" :key="trait.id">
                        <v-value :value="customer | valueForTrait(trait)" />
                    </td>
                </tr>
            </tbody>
        </v-table>
    </div>

</template>

<style scoped lang="scss">

    .customers {
        background: #fff;
        flex-grow: 1;
        height: 100%;
        overflow: auto;
        position: relative;
        .table {
            border: none;
            left: 0;
            margin: 0;
            position: absolute;
            top: 0;
            width: 100%;
            thead th {
                background: #fff;
                border: none;
                position: sticky;
                top: 0;
                &::after {
                    background: $color-rule;
                    bottom: 0;
                    content: "";
                    height: 1px;
                    left: 0;
                    position: absolute;
                    width: 100%;
                }
            }
        }
    }

</style>

<script>

export default {

    props: {
        customers: {
            tyoe: Object,
            required: true,
        },
    },

    data() {
        return {
            selected: [],
        }
    },

    computed: {

        traits() {
            let traits = this.project.traits.filter(trait => {
                if (trait.visibility.list) {
                    return trait;
                }
            });
            return traits.sort((a, b) => a.sort - b.sort);
        },

    },

    watch: {

        selected(val) {
            this.$emit('selected', val);
        },

    },

    methods: {

        viewCustomer(e, customer) {
            if (e.target?.tagName === 'A') return;
            this.$router.push({
                name: 'customer',
                params: { id: customer.id },
            });
        },

        sort(key) {
            let query = Object.assign({}, this.$route.query);
            let dir = query.sort_dir === 'desc' ? 'asc' : 'desc';
            query.page = 1;
            query.sort_key = key;
            query.sort_dir = dir;
            this.$router.replace({ query: query }).catch(() => {});
        },

        selectAll(val) {
            if (val) this.selected = this.customers.map(c => c.id);
            if (!val && this.selected.length === this.customers.length) this.selected = [];
        },

        selectRow(id, val) {
            let index = this.selected.indexOf(id);
            if (val && index < 0) this.selected.push(id);
            if (!val && index >= 0) this.selected.splice(index, 1);
        },

        deselectAll() {
            this.selected = [];
        },
    }

}

</script>
